import { EMPTY_LIST } from '../../../constants/common'
import { useDateLocale, useTimeZone } from '../../../hooks'
import { getQaSelector } from '../../../utils/common'
import { QA_NAME_CALENDAR_GRID } from '../CalendarGrid.constants'
import { getCalendarGridAllDayItems } from '../CalendarGrid.utils'

import { useCalendarGridWeekSelection } from './CalendarGridWeek.hooks'
import {
  getCalendarGridFirstHour,
  getCalendarGridHourLabels,
  getCalendarGridWeekItemsByDay,
  getCalendarGridWeekStyle,
} from './CalendarGridWeek.utils'
import { CalendarGridWeekAllDay } from './CalendarGridWeekAllDay'
import { CalendarGridWeekColumn } from './CalendarGridWeekColumn'
import { CalendarGridWeekHead } from './CalendarGridWeekHead'
import { CalendarGridWeekHours } from './CalendarGridWeekHours'

import * as styles from './CalendarGridWeek.module.css'

function CalendarGridWeek({
  canMoveItems,
  canMoveItemsInTime,
  dayLoads,
  days,
  items,
  now,
  previewItem,
  today,
  onClickEmptyCell,
  onClickItem,
  onClickSecondaryLabel,
  onSelectEmptyRange,
}) {
  const locale = useDateLocale()
  const timezone = useTimeZone()

  const { getIsCellSelected, handlePointerDownCell, handlePointerEnterCell } =
    useCalendarGridWeekSelection({ onSelectRange: onSelectEmptyRange })

  const firstHour = getCalendarGridFirstHour({ items, locale, timezone })

  const hours = getCalendarGridHourLabels(firstHour)

  const { itemsByDay, outsideHoursItemsByDay } = getCalendarGridWeekItemsByDay({
    firstHour,
    items,
    locale,
    timezone,
  })

  return (
    <div
      {...getQaSelector({ value: QA_NAME_CALENDAR_GRID })}
      className={styles.CalendarGridWeek}
      style={getCalendarGridWeekStyle(days)}
    >
      <CalendarGridWeekHead
        days={days}
        outsideHoursItemsByDay={outsideHoursItemsByDay}
        today={today}
        onClickItem={onClickItem}
        onClickSecondaryLabel={onClickSecondaryLabel}
      />
      <CalendarGridWeekAllDay
        canMoveItems={canMoveItems}
        dayLoads={dayLoads}
        days={days}
        items={getCalendarGridAllDayItems(items)}
        today={today}
        onClickItem={onClickItem}
        onClickSecondaryLabel={onClickSecondaryLabel}
      />
      <CalendarGridWeekHours hours={hours} />
      {days.map(day => (
        <CalendarGridWeekColumn
          canMoveItemsInTime={canMoveItemsInTime}
          day={day}
          days={days}
          firstHour={firstHour}
          getIsCellSelected={getIsCellSelected}
          hours={hours}
          items={itemsByDay[day.date] ?? EMPTY_LIST}
          key={day.date}
          now={now}
          previewItem={previewItem}
          today={today}
          onClickEmptyCell={onClickEmptyCell}
          onClickItem={onClickItem}
          onClickSecondaryLabel={onClickSecondaryLabel}
          onPointerDownCell={handlePointerDownCell}
          onPointerEnterCell={handlePointerEnterCell}
        />
      ))}
    </div>
  )
}

export default CalendarGridWeek
